export function iframeVideo() {

  return {

    prefersReducedMotion: false,

    init() {
      let _prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (_prefersReducedMotion instanceof MediaQueryList) {
        const _mediaQueryListener = (event) => {
          this.prefersReducedMotion = event.matches;
        };

        _prefersReducedMotion.addEventListener('change', _mediaQueryListener);
        this.prefersReducedMotion = _prefersReducedMotion.matches;
      }
    }
  };
}
